import 'date-fns'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import DateFnsUtils from '@date-io/date-fns'
import { useIntl } from 'react-intl'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

const useStyles = makeStyles({
  grid: {
    width: '60%',
  },
  datepicker: {
    '& input': {
      padding: '18.5px 14px',
    },
  },
})

export default function MaterialUIPickers(props) {
  const { formatMessage } = useIntl()
  const { value, handleDateChange, passportExpiresAtMaxDate, ...inputProps } =
    props

  const classes = useStyles()

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        id="mui-pickers-date"
        label={formatMessage({ id: 'subscriber.form.date_of_birth' })}
        name="newGroupName"
        inputVariant="outlined"
        className={classes.datepicker}
        format="MM/dd/yyyy"
        value={value}
        onChange={handleDateChange}
        fullWidth
        maxDate={passportExpiresAtMaxDate || new Date()}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        {...inputProps}
      />
    </MuiPickersUtilsProvider>
  )
}
